module.exports = __webpack_public_path__ + "static/media/articlecomment.ed028af5.png";